// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file notifications/v1/model.proto (package notifications.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file notifications/v1/model.proto.
 */
export const file_notifications_v1_model: GenFile = /*@__PURE__*/
  fileDesc("Chxub3RpZmljYXRpb25zL3YxL21vZGVsLnByb3RvEhBub3RpZmljYXRpb25zLnYxKvwIChBOb3RpZmljYXRpb25UeXBlEiEKHU5PVElGSUNBVElPTl9UWVBFX1VOU1BFQ0lGSUVEEAASLQopTk9USUZJQ0FUSU9OX1RZUEVfUVVFU1RJT05OQUlSRV9DT01QTEVURUQQARIrCidOT1RJRklDQVRJT05fVFlQRV9RVUVTVElPTk5BSVJFX0RFTEVURUQQAhImCiJOT1RJRklDQVRJT05fVFlQRV9RVUVTVElPTl9VUERBVEVEEAMSLgoqTk9USUZJQ0FUSU9OX1RZUEVfVEhSRUFEX01BUktFRF9VTlJFU09MVkVEEAQSMAosTk9USUZJQ0FUSU9OX1RZUEVfVVNFUl9FTlRFUkVEX1FVRVNUSU9OTkFJUkUQBRIjCh9OT1RJRklDQVRJT05fVFlQRV9DT01NRU5UX0FEREVEEAYSOAo0Tk9USUZJQ0FUSU9OX1RZUEVfUVVFU1RJT05OQUlSRV9WMl9SRUNJUElFTlRfSU5WSVRFRBAHEkIKPk5PVElGSUNBVElPTl9UWVBFX1FVRVNUSU9OTkFJUkVfVjJfSU5GT19RVUVTVElPTk5BSVJFX0NPTVBMRVRFEAgSQQo9Tk9USUZJQ0FUSU9OX1RZUEVfUVVFU1RJT05OQUlSRV9WMl9JTkZPX1FVRVNUSU9OTkFJUkVfREVMRVRFRBAJEkIKPk5PVElGSUNBVElPTl9UWVBFX1FVRVNUSU9OTkFJUkVfVjJfUklTS19RVUVTVElPTk5BSVJFX0NPTVBMRVRFEAoSPwo7Tk9USUZJQ0FUSU9OX1RZUEVfUVVFU1RJT05OQUlSRV9WMl9ORVdfTUFOVUFMX1FVRVNUSU9OTkFJUkUQCxIwCixOT1RJRklDQVRJT05fVFlQRV9RVUVTVElPTk5BSVJFX1YyX1NVQk1JVFRFRBAMEjkKNU5PVElGSUNBVElPTl9UWVBFX1FVRVNUSU9OTkFJUkVfVjJfUkVDSVBJRU5UX1JFTUlOREVSEA0SNwozTk9USUZJQ0FUSU9OX1RZUEVfSU5UQUtFX1JFUVVFU1RfU1VCTUlUVEVEX0lOVEVSTkFMEA4SNwozTk9USUZJQ0FUSU9OX1RZUEVfSU5UQUtFX1JFUVVFU1RfU1VCTUlUVEVEX0VYVEVSTkFMEA8SNgoyTk9USUZJQ0FUSU9OX1RZUEVfSU5UQUtFX1JFUVVFU1RfQVBQUk9WRURfRVhURVJOQUwQEBI2CjJOT1RJRklDQVRJT05fVFlQRV9JTlRBS0VfUkVRVUVTVF9SRUpFQ1RFRF9FWFRFUk5BTBAREkIKPk5PVElGSUNBVElPTl9UWVBFX1FVRVNUSU9OTkFJUkVfVjJfUklTS19RVUVTVElPTk5BSVJFX1JFT1BFTkVEEBISLworTk9USUZJQ0FUSU9OX1RZUEVfT1VUUkVBQ0hfQ0FNUEFJR05fSU5WSVRFRBATEjAKLE5PVElGSUNBVElPTl9UWVBFX09VVFJFQUNIX0NBTVBBSUdOX1JFTUlOREVSEBQqRwoFQWN0b3ISFQoRQUNUT1JfVU5TUEVDSUZJRUQQABITCg9BQ1RPUl9SRUNJUElFTlQQARISCg5BQ1RPUl9BU1NFU1NPUhACKpABChdDb21tZW50Tm90aWZpY2F0aW9uVHlwZRIpCiVDT01NRU5UX05PVElGSUNBVElPTl9UWVBFX1VOU1BFQ0lGSUVEEAASJQohQ09NTUVOVF9OT1RJRklDQVRJT05fVFlQRV9NRU5USU9OEAESIwofQ09NTUVOVF9OT1RJRklDQVRJT05fVFlQRV9SRVBMWRACQs4BChRjb20ubm90aWZpY2F0aW9ucy52MUIKTW9kZWxQcm90b1ABWklnaXRodWIuY29tL2xlbWEuYWkvbGVtbWF0YS9hcGkvcHJvdG8vZ2VuL25vdGlmaWNhdGlvbnMvdjE7bm90aWZpY2F0aW9uc3YxogIDTlhYqgIQTm90aWZpY2F0aW9ucy5WMcoCEE5vdGlmaWNhdGlvbnNcVjHiAhxOb3RpZmljYXRpb25zXFYxXEdQQk1ldGFkYXRh6gIRTm90aWZpY2F0aW9uczo6VjFiBnByb3RvMw");

/**
 * @generated from enum notifications.v1.NotificationType
 */
export enum NotificationType {
  /**
   * @generated from enum value: NOTIFICATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_QUESTIONNAIRE_COMPLETED = 1;
   */
  QUESTIONNAIRE_COMPLETED = 1,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_QUESTIONNAIRE_DELETED = 2;
   */
  QUESTIONNAIRE_DELETED = 2,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_QUESTION_UPDATED = 3;
   */
  QUESTION_UPDATED = 3,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_THREAD_MARKED_UNRESOLVED = 4;
   */
  THREAD_MARKED_UNRESOLVED = 4,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_USER_ENTERED_QUESTIONNAIRE = 5;
   */
  USER_ENTERED_QUESTIONNAIRE = 5,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_COMMENT_ADDED = 6;
   */
  COMMENT_ADDED = 6,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_QUESTIONNAIRE_V2_RECIPIENT_INVITED = 7;
   */
  QUESTIONNAIRE_V2_RECIPIENT_INVITED = 7,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_QUESTIONNAIRE_V2_INFO_QUESTIONNAIRE_COMPLETE = 8;
   */
  QUESTIONNAIRE_V2_INFO_QUESTIONNAIRE_COMPLETE = 8,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_QUESTIONNAIRE_V2_INFO_QUESTIONNAIRE_DELETED = 9;
   */
  QUESTIONNAIRE_V2_INFO_QUESTIONNAIRE_DELETED = 9,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_QUESTIONNAIRE_V2_RISK_QUESTIONNAIRE_COMPLETE = 10;
   */
  QUESTIONNAIRE_V2_RISK_QUESTIONNAIRE_COMPLETE = 10,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_QUESTIONNAIRE_V2_NEW_MANUAL_QUESTIONNAIRE = 11;
   */
  QUESTIONNAIRE_V2_NEW_MANUAL_QUESTIONNAIRE = 11,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_QUESTIONNAIRE_V2_SUBMITTED = 12;
   */
  QUESTIONNAIRE_V2_SUBMITTED = 12,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_QUESTIONNAIRE_V2_RECIPIENT_REMINDER = 13;
   */
  QUESTIONNAIRE_V2_RECIPIENT_REMINDER = 13,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_INTAKE_REQUEST_SUBMITTED_INTERNAL = 14;
   */
  INTAKE_REQUEST_SUBMITTED_INTERNAL = 14,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_INTAKE_REQUEST_SUBMITTED_EXTERNAL = 15;
   */
  INTAKE_REQUEST_SUBMITTED_EXTERNAL = 15,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_INTAKE_REQUEST_APPROVED_EXTERNAL = 16;
   */
  INTAKE_REQUEST_APPROVED_EXTERNAL = 16,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_INTAKE_REQUEST_REJECTED_EXTERNAL = 17;
   */
  INTAKE_REQUEST_REJECTED_EXTERNAL = 17,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_QUESTIONNAIRE_V2_RISK_QUESTIONNAIRE_REOPENED = 18;
   */
  QUESTIONNAIRE_V2_RISK_QUESTIONNAIRE_REOPENED = 18,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_OUTREACH_CAMPAIGN_INVITED = 19;
   */
  OUTREACH_CAMPAIGN_INVITED = 19,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_OUTREACH_CAMPAIGN_REMINDER = 20;
   */
  OUTREACH_CAMPAIGN_REMINDER = 20,
}

/**
 * Describes the enum notifications.v1.NotificationType.
 */
export const NotificationTypeSchema: GenEnum<NotificationType> = /*@__PURE__*/
  enumDesc(file_notifications_v1_model, 0);

/**
 * @generated from enum notifications.v1.Actor
 */
export enum Actor {
  /**
   * @generated from enum value: ACTOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACTOR_RECIPIENT = 1;
   */
  RECIPIENT = 1,

  /**
   * @generated from enum value: ACTOR_ASSESSOR = 2;
   */
  ASSESSOR = 2,
}

/**
 * Describes the enum notifications.v1.Actor.
 */
export const ActorSchema: GenEnum<Actor> = /*@__PURE__*/
  enumDesc(file_notifications_v1_model, 1);

/**
 * @generated from enum notifications.v1.CommentNotificationType
 */
export enum CommentNotificationType {
  /**
   * @generated from enum value: COMMENT_NOTIFICATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COMMENT_NOTIFICATION_TYPE_MENTION = 1;
   */
  MENTION = 1,

  /**
   * @generated from enum value: COMMENT_NOTIFICATION_TYPE_REPLY = 2;
   */
  REPLY = 2,
}

/**
 * Describes the enum notifications.v1.CommentNotificationType.
 */
export const CommentNotificationTypeSchema: GenEnum<CommentNotificationType> = /*@__PURE__*/
  enumDesc(file_notifications_v1_model, 2);

